module.exports = __webpack_public_path__ + "img/doctor.cc9da53e.svg";